import { AlertService } from '../../shared/services/alert.service';
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from "../../login/services/auth.service";
import { AssessmentService } from "../../shared/services/assessment.service";
import { AssessmentGraderService } from "../../shared/services/assessment-grader.service";
import { AssetService } from 'app/library-assets/services/asset.service';
var TakeAssignmentComponent = /** @class */ (function () {
    function TakeAssignmentComponent(AssessmentService, router, authService, route, assessmentGrader, assetService, alertService) {
        this.AssessmentService = AssessmentService;
        this.router = router;
        this.authService = authService;
        this.route = route;
        this.assessmentGrader = assessmentGrader;
        this.assetService = assetService;
        this.alertService = alertService;
    }
    Object.defineProperty(TakeAssignmentComponent.prototype, "hasAssignment", {
        get: function () {
            return this._assignment && this._assignment.Name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TakeAssignmentComponent.prototype, "assignmentName", {
        get: function () {
            if (this._assignment) {
                return this._assignment.Name;
            }
            return "";
        },
        enumerable: true,
        configurable: true
    });
    TakeAssignmentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authService.getCurrentClient().then(function (client) {
            _this._client = client;
            // not sure I like this nested, but it does handle duplicate requests for the uid.
            _this.route.params.subscribe(function (params) {
                _this.loading = true;
                var id = +params['id'];
                if (isNaN(id)) {
                    _this.alertService.error("Assessment id was not a valid number.  Cannot load");
                    return;
                }
                _this._assignment = client.findAssignmentItem(id);
                console.log("Loading assignment ", _this._assignment);
                if (_this._assignment.Type == 'Assessment') {
                    var assignedAssessment = _this._assignment;
                    _this.AssessmentService.clientId = client.id;
                    _this.AssessmentService.getAssessmentForAssignment(assignedAssessment).then(function (assessment) {
                        _this.loading = false;
                        _this._assessment = assessment;
                    })
                        .catch(function (response) {
                        _this.loading = false;
                        _this.alertService.error("Failed to load assessment.  Please check your network connection or contact customer support");
                        console.error(response);
                    });
                }
                else {
                    var libraryAsset = _this._assignment;
                    _this.assetService.getAsset(libraryAsset.AssetId).then(function (asset) {
                        _this._loading = false;
                        _this._asset = asset;
                    })
                        .catch(function (response) {
                        _this.loading = false;
                        _this.alertService.error("Failed to load assignment.  Please check your network connection or contact customer support");
                        console.error(response);
                    });
                }
            });
        });
    };
    TakeAssignmentComponent.prototype.submitAsset = function (assetResult) {
        // create the exercise results
        var _this = this;
        // grab all the answers
        var savingMsg = this.alertService.info("Saving your assignment....", 600000);
        assetResult.assignmentItemId = this._assignment.Id;
        this.assetService.saveAssetResult(assetResult).then(function (result) {
            _this.alertService.success("Saved answers for " + result.asset.title);
            _this.alertService.clearAlert(savingMsg);
            // TODO: stephen not sure I like this as the assignment and the client have to maintain knowledge of each other
            // of course we need it as we need to grab the next assignment from the client..
            _this._assignment.ResultId = result.id;
            _this._client.markAssignmentCompleted(_this._assignment);
            _this.navigateToNextDestinationForAssignmentItem(_this._assignment);
        })
            .catch(function (error) {
            _this.alertService.clearAlert(savingMsg);
            console.error("Failed to save json result", error);
            _this.saving = false;
            _this.alertService.error("There was an error in saving your assignment. Please check your internet connection or try again. If you continue to have problems please contact us via our contact page.", 5000);
        });
    };
    TakeAssignmentComponent.prototype.submitAssessment = function (assessment) {
        var _this = this;
        this.saving = false;
        var result = this.createAssessmentResultFromAssessment(assessment);
        this.saving = true;
        var savingMsg = this.alertService.info("Computing your test results and saving your scores....", 600000);
        this.AssessmentService.saveAssessmentResult(result)
            .then(function (result) {
            _this.alertService.success("Saved results for " + _this.assignmentName);
            _this.alertService.clearAlert(savingMsg);
            setTimeout(function () {
                var assignment = _this._assignment;
                assignment.ResultId = result.id; // this is all saved server side, but we'll put it here
                // TODO: stephen not sure I like this as the assignment and the client have to maintain knowledge of each other
                // of course we need it as we need to grab the next assignment from the client..
                _this._client.markAssignmentCompleted(_this._assignment);
                _this.navigateToNextDestinationForAssignmentItem(_this._assignment);
            }, 1000); // have a slight delay to show we are doing something
        })
            .catch(function (error) {
            _this.alertService.clearAlert(savingMsg);
            console.error("Failed to save json result", error);
            _this.saving = false;
            _this.alertService.error("There was an error in saving your assessment. Please check your internet connection or try again. If you continue to have problems please contact us via our contact page.", 5000);
        });
    };
    TakeAssignmentComponent.prototype.navigateToNextDestinationForAssignmentItem = function (item) {
        if (!this._client.hasFinishedAllAssignments()) {
            var itemAssignment = this._client.getNextAssignmentItemToComplete();
            this.saving = false;
            this.router.navigate(["../", itemAssignment.Id], { relativeTo: this.route });
        }
        else {
            this.alertService.success("Congratulations!  You have finished your assigned assessments");
            this.router.navigate(["../../"], { relativeTo: this.route });
        }
    };
    TakeAssignmentComponent.prototype.createAssessmentResultFromAssessment = function (assessment) {
        var result = this.assessmentGrader.grade(assessment);
        result.assignmentItemId = this._assignment.Id;
        return result;
    };
    TakeAssignmentComponent.prototype.shouldDisplayAssessment = function () {
        return this._assignment && this._assignment.Type == 'Assessment';
    };
    TakeAssignmentComponent.prototype.shouldDisplayExercise = function () {
        return this._assignment && this._assignment.Type == 'LibraryAsset' && this._asset && this._asset.type == 'assignment';
    };
    TakeAssignmentComponent.prototype.shouldDisplayArticle = function () {
        return this._assignment && this._assignment.Type == 'LibraryAsset' && this._asset && this._asset.type == 'article';
    };
    Object.defineProperty(TakeAssignmentComponent.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        set: function (v) {
            this._loading = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TakeAssignmentComponent.prototype, "saving", {
        get: function () {
            return this._saving;
        },
        set: function (v) {
            this._saving = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TakeAssignmentComponent.prototype, "assessment", {
        get: function () {
            return this._assessment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TakeAssignmentComponent.prototype, "asset", {
        get: function () {
            return this._asset;
        },
        enumerable: true,
        configurable: true
    });
    return TakeAssignmentComponent;
}());
export { TakeAssignmentComponent };



// WEBPACK FOOTER //
// ./src/app/assessments/take-assignment/take-assignment.component.ts.pre-build-optimizer.js